import type { PuzzleColor, PuzzleInput } from "./types";

export const PUZZLE_TICK_RATE = 30;
export const PUZZLE_FIXED_DELTA_SECONDS = 1 / PUZZLE_TICK_RATE;

/** Pixel-space board dimensions used by both the simulation and renderer. */
export const PUZZLE_BOARD_WIDTH = 340;
export const PUZZLE_BOARD_HEIGHT = 760;
export const PUZZLE_BOARD_COLUMNS = 8;
export const PUZZLE_BOARD_ROWS = 18;
export const PUZZLE_BUBBLE_RADIUS = 20;
export const PUZZLE_HEX_ROW_HEIGHT = 35;

export const PUZZLE_SHOOTER_X = PUZZLE_BOARD_WIDTH / 2;
export const PUZZLE_SHOOTER_Y = 720;
export const PUZZLE_SHOOTER_POSITION = Object.freeze({
  x: PUZZLE_SHOOTER_X,
  y: PUZZLE_SHOOTER_Y,
});
/** Row 17 touches this line, leaving rows 0-16 as the playable safe area. */
export const PUZZLE_DANGER_LINE_Y = 635;
export const PUZZLE_DANGER_LINE = PUZZLE_DANGER_LINE_Y;

/**
 * Safe launcher arc. Keeping five degrees away from horizontal prevents a
 * pointer dragged below the launcher from appearing to wrap to the far side.
 */
export const PUZZLE_MIN_AIM = -70;
export const PUZZLE_MAX_AIM = 70;
export const PUZZLE_PROJECTILE_SPEED = 540;
export const PUZZLE_SHOT_SUBSTEPS = 4;
export const PUZZLE_MAX_SHOT_TICKS = 8 * PUZZLE_TICK_RATE;

export const PUZZLE_INITIAL_ROWS = 5;
export const PUZZLE_MISSES_PER_PRESSURE = 5;
export const PUZZLE_MAX_ATTACK_ROWS = 2;
/** A combo full row is materialized as eight bubbles under the target cluster. */
export const PUZZLE_ATTACK_BUBBLES_PER_ROW = PUZZLE_BOARD_COLUMNS;
/**
 * Hard cap for the combined queued attack payload. Combo rows consume eight
 * slots each and transfer bubbles consume one slot each.
 */
export const PUZZLE_MAX_PENDING_ATTACK_BUBBLES = 24;

export const PUZZLE_ROUND_TICKS = 90 * PUZZLE_TICK_RATE;
export const PUZZLE_COUNTDOWN_TICKS = 3 * PUZZLE_TICK_RATE;
export const PUZZLE_ROUND_END_TICKS = 2 * PUZZLE_TICK_RATE;
export const PUZZLE_ROUNDS_TO_WIN = 2;
/** Overtime adds one ceiling row every 2.5 seconds (twice the normal v0.7 pace). */
export const PUZZLE_OVERTIME_PRESSURE_INTERVAL_TICKS =
  (5 * PUZZLE_TICK_RATE) / 2;

export const PUZZLE_MATCH_POINTS_PER_BUBBLE = 10;
export const PUZZLE_DROP_POINTS_PER_BUBBLE = 20;

export const PUZZLE_COLORS: ReadonlyArray<PuzzleColor> = Object.freeze([
  "cyan",
  "coral",
  "lime",
  "violet",
  "gold",
]);

export const PUZZLE_EMPTY_INPUT: Readonly<PuzzleInput> = Object.freeze({
  aim: 0,
  fire: false,
  hold: false,
});
